import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 74 85"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M67.695 1.526C70.345-.342 74 1.553 74 4.796V56.64a4 4 0 0 1-1.678 3.257l-33 23.527a4 4 0 0 1-4.644 0l-33-23.527A4 4 0 0 1 0 56.641V4.795C0 1.553 3.655-.342 6.305 1.526l28.39 20.016a4 4 0 0 0 4.61 0z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }